module.exports = __webpack_public_path__ + "img/trauma-and-assault.23cd43ca.png";